import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { state } from './state';

export const filters = {
    actions,
    getters,
    mutations,
    state
};



// WEBPACK FOOTER //
// ./src/store/modules/filters/index.js